import { Directive, HostListener } from '@angular/core';
import { Input } from '@angular/core';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { CommunityService } from '../services/community.service';
import { Page, Activity } from '../model/data-layer';

@Directive({
    // tslint:disable-next-line:directive-selector
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[gaEvent]',
    standalone: false
})
export class GoogleAnalyticsEventDirective {
    @Input()
    gaPage: Page;

    @Input()
    gaActivity: Activity;

    constructor(
        private googleAnalyticsService: GoogleAnalyticsService,
        private communityService: CommunityService,
    ) {}

    @HostListener('click', ['$event'])
    public onClick(_event) {
        if (this.gaPage && this.gaActivity) {
            this.googleAnalyticsService.event(this.gaPage, this.gaActivity);
        }
    }
}
